import module from 'viaticos/module.js'
import template from './template.html'
import * as moment from 'moment'

export class ViaticosCerrarListaComponent {
  busqueda
  catalogos = {
    gasto_categoria: [],
    moneda: [],
  }
  seleccionado = null
  resultados = undefined
  filtro = {
    general: undefined,
  }

  constructor ($filter, $q, $export, ViaticosCerrarService, ViaticosCatalgosCategoriasviaticoService, ViaticosCatalogosMonedasService) {
    this.filterBy = $filter('filter')
    this.$q = $q
    this.$export = $export
    this.ViaticosCerrarService = ViaticosCerrarService
    this.ViaticosCatalgosCategoriasviaticoService = ViaticosCatalgosCategoriasviaticoService
    this.ViaticosCatalogosMonedasService = ViaticosCatalogosMonedasService
  }

  $onInit () {
    this.promise = this.$q.all([
      this.ViaticosCerrarService.get(this.busqueda.fechaInicial, this.busqueda.fechaFinal)
        .then(({data}) => (this.data = data)),
      this.ViaticosCatalgosCategoriasviaticoService.get()
        .then(({data}) => (this.catalogos.gasto_categoria = data)),
      this.ViaticosCatalogosMonedasService.get()
        .then(({data}) => (this.catalogos.moneda = data)),
    ])
  }

  filtrar () {
    if (this.filtro.general) {
      this.resultados = this.filterBy(this.data, this.filtro.general)
    } else {
      this.resultados = [...this.data]
    }

    this.resultadosOcultos = this.data.length - this.resultados.length
  }

  exportar () {
    const encabezados = [
      {label: 'Nombre', format: {align: 'left', width: 40}},
      {label: 'Motivo', format: {align: 'left', width: 40}},
      {label: 'Origen', format: {align: 'left', width: 40}},
      {label: 'Destino', format: {align: 'left', width: 40}},
      {label: 'Inicio', format: {align: 'left', width: 40}},
      {label: 'Fin', format: {align: 'left', width: 40}},
      {label: 'Depósitos', format: {align: 'right', width: 40, type: 'currency'}},
      {label: 'Comprobantes', format: {align: 'right', width: 40, type: 'currency'}},
      {label: 'Diferencia', format: {align: 'right', width: 40, type: 'currency'}},
      {label: 'Proyecto', format: {align: 'left', width: 40}},
      {label: 'Operadora', format: {align: 'left', width: 40}},
      {label: 'Notas', format: {align: 'left', width: 40}},
    ]

    const data = this.resultados.map((item) => {
      return {
        nombre: item.nombre,
        motivo: item.motivo,
        origen: item.origen,
        destino: item.destino,
        fecha_inicial: moment(item.fecha_inicial, 'DD/MM/YYYY'),
        fecha_final: moment(item.fecha_final, 'DD/MM/YYYY'),
        suma_anticipos: item.suma_anticipos,
        suma_detalles: item.suma_detalles,
        diferencia: item.diferencia,
        proyecto: item.empresa,
        operadora: item.operadora,
        notas: item.notas,
      }
    })

    this.$export.excel('Viaticos', [{
      name: (this.estados.find((item) => item.id == this.filtro.estado) || {}).descripcion || 'Todos',// Fixme
      columns: encabezados,
      options: {
        logo: {
          filename: '/api/export/images/FAN-logo.png',
          title: 'FAN Consultores',
          cell: 'A1',
        },
        show_grid: false,
        fixed_column: 'A8',
      },
      data,
    }])
  }
}

module.component('viaticosCerrarLista', {
  controller: ViaticosCerrarListaComponent,
  template,
  bindings: {
    busqueda: '<',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/cerrar/lista/component.js